import { Game } from '../types'

const getUserRole = (game: Game): string | null => {
  const roles = game?.user_active_game_roles
  if (!roles) {
    return null
  }

  const labels: string[] = []

  if (roles.is_player) {
    labels.push('PLAYER')
  }
  if (roles.is_team_official) {
    labels.push('TEAM OFFICIAL')
  }
  if (roles.is_game_official) {
    labels.push('GAME OFFICIAL')
  }
  if (roles.is_team_video_permission && game?.feature_flags?.livestreaming) {
    labels.push('VIDEOGRAPHER')
  }

  return labels.length > 0 ? labels.join(', ') : null
}

export default getUserRole
